import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { Router, RouterLink, ActivatedRoute, ParamMap }          from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import {ApiService} from "../api.service";

@Component({
  selector: 'verify-email',
  templateUrl: './verify-email.component.html'
})
export class VerifyEmailComponent implements OnInit {
    activateForm = new FormGroup({
        code: new FormControl('', [Validators.required, Validators.minLength(4)]),
    });
    constructor(private router: Router, private route: ActivatedRoute,  private apiService: ApiService) { }

    ngOnInit() {
        let code = this.route.snapshot.paramMap.get('code');
        if (code) {
            this.activateForm.setValue({'code': code});
            this.apiService.activateNewsletter(code).subscribe(resp => {
                this.router.navigateByUrl('/subscription-confirmed');
            });
        }

    }
    onSubmit() {
        if(!this.activateForm.valid) {
            console.log("stop form invalid");
            return;
        };
        this.apiService.activateNewsletter(this.activateForm.value.code).subscribe(resp => {
            this.router.navigateByUrl('/subscription-confirmed');
        });
    }
}
